/**
 * Currency formatters for financial display.
 * Amounts are always strings (P-02: never use float/double for money).
 */

const arsFormatter = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatARS(amount: string): string {
  return arsFormatter.format(Number(amount));
}

export function formatUSD(amount: string): string {
  return usdFormatter.format(Number(amount));
}

export function formatCurrency(amount: string, currency: 'ARS' | 'USD'): string {
  return currency === 'ARS' ? formatARS(amount) : formatUSD(amount);
}
